module.exports = __webpack_public_path__ + "static/media/YM80_5.654e62bc.jpg";